module.exports = __webpack_public_path__ + "img/icon24.04f04efd.png";